import React from 'react';
import Proptypes from 'prop-types';

import { MBox } from '../../../../atoms/MBox';
import { ProductImage } from '../../../../atoms/ProductImage';
import { MText } from '../../../../atoms/MText';

import MCheckBox from '../../../../atoms/MCheckBox';

import PriceDetails from '../../../../molecules/PriceDetails';
import ProductActionButtons from '../../../../molecules/ProductActionButtons';

import { StyledCheckboxProductItemCon } from './skins';

export default function CheckboxProduct(props) {
  const {
    isMobile,
    product,
    selectedVariant,
    theme,
    priceDetailStyles,
    getProductAndSelectedVariantData,
    productActionButtonStyles,
  } = props;

  // destructuring curr product item and selected variant data
  // go to function defination for each variable info
  const {
    selectedImage: { src: selectedImage },
    offerPrice,
    price,
    off,
    isDiscountDisabled,
    showFree,
    onProductImageClick,
    onProductTitleClick,
    handleVariantChange,
    onAddClick,
    onAddProductToAddon,
    getIndexInSelectedCheckboxProducts,
    quantityAdded,
    variantOptions,
    showVariantSelector,
    showATCButton,
    withoutFirstAction,
    variantFiller,
    variantFillerStyles,
    variantAtcStatus,
    isMaxQtyAdded,
    isDisableProductAddition,
  } = getProductAndSelectedVariantData(product, selectedVariant);

  const productActionButtonsProps = {
    quantityAdded,
    showVariantSelector,
    showATCButton,
    withoutFirstAction,
    variantFiller,
    variantFillerStyles,
    variantSelectorValue: selectedVariant.title,
    variantSelectorOptions: variantOptions,
    handleVariantChange,
    onAddClick,
    variantAtcStatus,
    isMaxQtyAdded,
    ...productActionButtonStyles,
  };

  const isProductChecked =
    getIndexInSelectedCheckboxProducts(product.originalIndex) > -1;

  let isProductDisabled = false;

  if (isDisableProductAddition && !isProductChecked) {
    isProductDisabled = true;
  }

  return (
    <>
      <StyledCheckboxProductItemCon
        padding={
          isMobile ? theme.productItemMobilePadding : theme.productItemPadding
        }
        margin={
          isMobile ? theme.productItemMobileMargin : theme.productItemMargin
        }
        mobilePadding={theme.productItemMobilePadding}
        mobileMargin={theme.productItemMobileMargin}
        className="mr-product-item mr-product-item--cross-sell mr-product-item--checkbox"
      >
        <MCheckBox
          className="mr-product-item__checkbox"
          onChange={onAddProductToAddon}
          checked={isProductChecked}
          disabled={isProductDisabled}
          borderColor={theme.productAddonCheckboxBorderColor}
          borderRadius={theme.productAddonCheckboxBorderRadius}
          tickBgColor={theme.productAddonCheckboxBackgroundColor}
          tickColor={theme.productAddonCheckboxTickColor}
          width="24"
          margin="auto 0px"
        />
        <ProductImage
          src={selectedImage}
          width={
            isMobile ? theme.productImageMobileWidth : theme.productImageWidth
          }
          height={
            isMobile ? theme.productImageMobileHeight : theme.productImageHeight
          }
          mobileWidth={theme.productImageMobileWidth}
          mobileHeight={theme.productImageMobileHeight}
          onImageClick={onProductImageClick}
          isBordered={theme.isProductImageBordered}
          borderColor={theme.productImageBorderColor}
          borderWidth={theme.productImageBorderWidth}
          borderRadius={
            isMobile
              ? theme.productImageMobileBorderRadius
              : theme.productImageBorderRadius
          }
          padding={theme.productImagePadding}
          margin={theme.productImageMargin}
          cursor={theme.isProductImageClickGoToPage ? 'pointer' : 'auto'}
        />
        <MBox
          padding={theme.productItemBodyPadding}
          margin={theme.productItemBodyMargin}
          className="mr-product-item__body"
        >
          <MBox className="mr-product-body__details">
            <MText
              color={theme.productNameTextColor}
              fontSize={
                isMobile
                  ? theme.productNameMobileFontSize
                  : theme.productNameFontSize
              }
              mobileFontSize={theme.productNameMobileFontSize}
              fontStyle={theme.productNameFontStyle}
              fontWeight={theme.productNameFontWeight}
              textDecoration={theme.productNameTextDecoration}
              fontFamily={theme.productNameFontFamily}
              textAlignment={
                isMobile
                  ? theme.productNameMobileTextAlignment
                  : theme.productNameTextAlignment
              }
              padding={
                isMobile
                  ? theme.productNameMobilePadding
                  : theme.productNamePadding
              }
              margin={
                isMobile
                  ? theme.productNameMobileMargin
                  : theme.productNameMargin
              }
              className="mr-product-details__product-title"
              onTextClick={onProductTitleClick}
              cursor={theme.isProductTitleClickGoToPage ? 'pointer' : 'auto'}
            >
              {product.title}
            </MText>
            {product.description && (
              <MText
                color={theme.productDescriptionTextColor}
                fontSize={
                  isMobile
                    ? theme.productDescriptionMobileFontSize
                    : theme.productDescriptionFontSize
                }
                mobileFontSize={theme.productNameMobileFontSize}
                fontStyle={theme.productDescriptionFontStyle}
                fontWeight={theme.productDescriptionFontWeight}
                textDecoration={theme.productDescriptionTextDecoration}
                fontFamily={theme.productDescriptionFontFamily}
                textAlignment={
                  isMobile
                    ? theme.productDescriptionMobileTextAlignment
                    : theme.productDescriptionTextAlignment
                }
                padding={theme.productDescriptionPadding}
                margin={theme.productDescriptionMargin}
                className="mr-product-details__product-description"
              >
                {product.description}
              </MText>
            )}
            <PriceDetails
              offerPrice={offerPrice}
              price={price}
              off={off}
              isDiscountDisabled={isDiscountDisabled}
              showFree={showFree}
              {...priceDetailStyles}
              textAlignment={
                isMobile
                  ? theme.productPriceMobileTextAlignment
                  : theme.productPriceTextAlignment
              }
              fontFamily={theme.productPriceFontFamily}
              padding={
                isMobile
                  ? theme.productPriceMobilePadding
                  : theme.productPricePadding
              }
              margin={
                isMobile
                  ? theme.productPriceMobileMargin
                  : theme.productPriceMargin
              }
              className="mr-product-item__price-con"
            />
          </MBox>
          <ProductActionButtons
            layout="vertical"
            withoutSecondAction
            {...productActionButtonsProps}
          />
        </MBox>
      </StyledCheckboxProductItemCon>
    </>
  );
}

CheckboxProduct.propTypes = {
  isMobile: Proptypes.bool.isRequired,
  product: Proptypes.object.isRequired,
  selectedVariant: Proptypes.object.isRequired,
  theme: Proptypes.object.isRequired,
  getProductAndSelectedVariantData: Proptypes.func.isRequired,
  priceDetailStyles: Proptypes.object,
  productActionButtonStyle: Proptypes.object,
  productActionButtonStyles: Proptypes.object,
  isOfferLevelDiscountQuantityLimitReached: Proptypes.bool,
  productLevelDiscountQuantity: Proptypes.number,
};
